import {
    ADD_INVENTORY_FAIL,
    ADD_INVENTORY_SUCCESS,
    UPDATE_LOWTHRESHOLD_FAIL,
    UPDATE_LOWTHRESHOLD_SUCCESS,
    EXPORT_INVENTORY_FAIL,
    EXPORT_INVENTORY_SUCCESS,
    EXPORT_INVENTORY_LOG_FAIL,
    EXPORT_INVENTORY_LOG_SUCCESS,
    GET_INVENTORY_DETAILS_FAIL,
    GET_INVENTORY_DETAILS_SUCCESS,
    GET_INVENTORY_LISTING_FAIL,
    GET_INVENTORY_LISTING_SUCCESS,
    RESET_INVENTORY_ATTACHMENT_STATE,
    RESET_INVENTORY_STATE,
    UPDATE_INVENTORY_FAIL,
    UPDATE_INVENTORY_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    inventoryListing: [],
    inventoryDetails: [],
    addInventory: [],
    updateInventory: [],
    updateLowTreshold: [],
    exportInventory: [],
    exportInventoryLog: [],
    error: [],
}

const Inventory = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_INVENTORY_LISTING_SUCCESS:
            return {
                ...state,
                inventoryListing: action.payload
            }
        case GET_INVENTORY_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_INVENTORY_DETAILS_SUCCESS:
            return {
                ...state,
                inventoryDetails: action.payload
            }
        case GET_INVENTORY_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_INVENTORY_SUCCESS:
            return {
                ...state,
                addInventory: action.payload
            }
        case ADD_INVENTORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_INVENTORY_SUCCESS:
            return {
                ...state,
                updateInventory: action.payload
            }
        case UPDATE_INVENTORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_LOWTHRESHOLD_SUCCESS:
            return {
                ...state,
                updateLowTreshold: action.payload
            }
        case UPDATE_LOWTHRESHOLD_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_INVENTORY_SUCCESS:
            return {
                ...state,
                exportInventory: action.payload
            }
        case EXPORT_INVENTORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_INVENTORY_LOG_SUCCESS:
            return {
                ...state,
                exportInventoryLog: action.payload
            }
        case EXPORT_INVENTORY_LOG_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_INVENTORY_STATE:
            return {
                ...state,
                inventoryListing: [],
                inventoryDetails: [],
                addInventory: [],
                updateInventory: [],
                updateLowTreshold: [],
                exportInventory: [],
                exportInventoryLog: [],
                error: [],
            }
        case RESET_INVENTORY_ATTACHMENT_STATE:
            return {
                ...state,
                exportInventory: [],
                exportInventoryLog: [],
                error: [],
            }
        default:
            return state
    }
}

export default Inventory
